// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2tmw_","badges":"styles_badges__Rfmm4"};